export class Helpers {
  static replaceUnderscore(value: string | null | undefined): string {
    if (!value?.trim()) return 'N/A';

    return value.replace(/_/g, ' ');
  }

  static toSentenceCase(value: string | null | undefined): string {
    if (!value?.trim()) return 'N/A';

    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  static replaceSpace(value: string | null | undefined): string {
    if (!value?.trim()) return 'N/A';

    return value.replace(/ /g, '_');
  }

  static formatDate(dateString: any): string {
    if (!dateString) {
      return 'N/A';
    }

    const date = new Date(dateString);

    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }

  static formatTime(timestamp: any): string {
    if (!timestamp) {
      return 'N/A';
    }

    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  }

  static numberToPosition(num: number): string {
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return `${num}th`;
    }

    switch (lastDigit) {
      case 1:
        return `${num}st`;
      case 2:
        return `${num}nd`;
      case 3:
        return `${num}rd`;
      default:
        return `${num}th`;
    }
  }

  static capitalizeWords(value: string | null | undefined): string {
    if (!value?.trim()) return '';

    return value
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  static fullName(user: {
    first_name: string | undefined | null;
    last_name: string | undefined | null;
  }): string {
    return `${user.first_name} ${user.last_name}`;
  }

  static getInitials(name: string): string {
    const names = name.trim().split(' ');

    if (names.length === 1) {
      return names[0][0].toUpperCase();
    }

    const firstInitial = names[0][0];
    const lastInitial = names[names.length - 1][0];

    return (firstInitial + lastInitial).toUpperCase();
  }

  static formatAmount(value: number | null | undefined): string {
    if (value == null) return '0';

    if (value >= 1_000_000_000) {
      return `${(value / 1_000_000_000).toFixed(1)}B`;
    }

    if (value >= 1_000_000) {
      return `${(value / 1_000_000).toFixed(1)}M`;
    }

    if (value >= 1_000) {
      return `${(value / 1_000).toFixed(1)}K`;
    }

    return value.toLocaleString('en-GH');
  }

  static getStatusStyle(percentage: number): { color: string; backgroundColor: string } {
    if (percentage <= 20) return { color: '#B91C1C', backgroundColor: '#FEE2E2' }; // red-100
    if (percentage <= 50) return { color: '#B45309', backgroundColor: '#FEF3C7' }; // amber-100
    return { color: '#15803D', backgroundColor: '#DCFCE7' }; // green-100
  }
}
